/** @meitu/upload 的 uploadMultiple 单次最多接收 20 个文件。 */
export const UPLOAD_SDK_MAX_BATCH_SIZE = 20;

/**
 * 按上传 SDK 的单批上限顺序执行批量任务，并保持最终结果与输入顺序一致。
 */
export async function uploadItemsInBatches<TItem, TResult>(
  items: TItem[],
  uploadBatch: (batchItems: TItem[]) => Promise<TResult[] | null>,
): Promise<TResult[] | null> {
  const results: TResult[] = [];

  for (let start = 0; start < items.length; start += UPLOAD_SDK_MAX_BATCH_SIZE) {
    const batchItems = items.slice(start, start + UPLOAD_SDK_MAX_BATCH_SIZE);
    // SDK 同一上传器顺序执行，避免多个 20 文件批次同时争抢内部任务状态。
    // eslint-disable-next-line no-await-in-loop
    const batchResults = await uploadBatch(batchItems);
    if (!batchResults || batchResults.length !== batchItems.length) return null;
    results.push(...batchResults);
  }

  return results;
}
